import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Hide the native splash the moment React has painted (Capacitor only).
// Web users never see this branch; the index.html app-shell handles them.
// We use a runtime-resolved module name so webpack doesn't try to bundle
// @capacitor/splash-screen (it's only present after Capacitor `npx cap sync`).
requestAnimationFrame(() => {
  if (typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.()) {
    const mod = "@capacitor/splash-screen";
    /* webpackIgnore: true */
    import(/* webpackIgnore: true */ mod)
      .then(({ SplashScreen }) => { SplashScreen.hide().catch(() => {}); })
      .catch(() => { /* plugin missing or not native — fine */ });
  }
});

registerServiceWorker();
